
/**
 * 투표 유형
 */
export type ReviewVoteRequestVote = typeof ReviewVoteRequestVote[keyof typeof ReviewVoteRequestVote];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReviewVoteRequestVote = {
  HELPFUL: 'HELPFUL',
  UNHELPFUL: 'UNHELPFUL',
} as const;
